import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { ConsumerReviewsEntities } from 'client/data/models/consumer-reviews';
import { FormField } from 'site-modules/shared/components/form-field/form-field';
import { ButtonsRadioInput } from 'site-modules/shared/components/buttons-radio-input/buttons-radio-input';
import { AUTHOR_INFO_OPTIONS } from 'site-modules/shared/constants/write-review/write-review';

export function AuthorInfo({ fieldRef, validate, reviewData = null }) {
  return (
    <Fragment>
      <div className="heading-4 mb-0_5">Tell other shoppers about yourself</div>
      <div className="mb-1_5">
        Help other shoppers know if this car is right for them by telling them about yourself.
      </div>
      {AUTHOR_INFO_OPTIONS.map(({ name, label, options }) => (
        <FormField
          key={name}
          labelClassName="heading-5 mb-0_5"
          className="mb-0_5"
          ref={fieldRef}
          tag={ButtonsRadioInput}
          label={label}
          name={name}
          id={name}
          options={options}
          onBlur={validate}
          onChange={validate}
          defaultValue={
            options.find(({ value }) => value === get(reviewData, `userProfile[${name}]`))
              ? get(reviewData, `userProfile[${name}]`)
              : undefined
          }
        />
      ))}
    </Fragment>
  );
}

AuthorInfo.propTypes = {
  fieldRef: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  reviewData: ConsumerReviewsEntities.ReviewData,
};
